var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPot1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "59px",
    viewBox: "0 0 33 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pot4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pricing",
    transform: "translate(-513.000000, -454.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pricing-Card",
    transform: "translate(383.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pot4",
    transform: "translate(130.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8218858,18.4384512 L18.8218858,13.1010048 L25.6072771,13.1006482 L25.6074262,10.2705408 C25.6074262,8.7073187 26.8732554,7.4400768 28.4347347,7.4400768 C29.9962141,7.4400768 31.2620433,8.7073187 31.2620433,10.2705408 L31.2620433,16.17408 C31.2620433,17.4246577 30.24938,18.4384512 29.0001965,18.4384512 L18.8218858,18.4384512 Z",
    id: "Path",
    fill: "#65E09C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74518975e-13,21.5115264 L4.74518975e-13,16.4166912 C4.74518975e-13,14.8534691 1.26582914,13.5862272 2.82730852,13.5862272 C4.3887879,13.5862272 5.65461704,14.8534691 5.65461704,16.4166912 L5.65426087,19.2465 L9.04626087,19.2465 L9.04738727,6.2270208 C9.04738727,2.78793218 11.8322114,1.92988482e-13 15.267466,1.92988482e-13 C18.7027207,1.92988482e-13 21.4875448,2.78793218 21.4875448,6.2270208 L21.4875448,38.4943104 L9.04738727,38.4943104 L9.04626087,24.9070714 L3.39277023,24.9080832 C1.51899497,24.9080832 4.74518975e-13,23.3873929 4.74518975e-13,21.5115264 Z",
    id: "Path",
    fill: "#28C76F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(0.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.43609322,0 L30.1579576,0 L28.1034693,28.1269223 C28.0472672,28.8963568 27.4228651,29.4912 26.6713982,29.4912 L4.92265262,29.4912 C4.1711857,29.4912 3.54678362,28.8963568 3.49058145,28.1269223 L1.43609322,0 Z",
    id: "Rectangle",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43609322,0 L30.1579576,0 C30.9510899,0 31.5940508,0.660182999 31.5940508,1.47456 L31.5940508,7.3728 C31.5940508,8.187177 30.9510899,8.84736 30.1579576,8.84736 L1.43609322,8.84736 C0.642960834,8.84736 0,8.187177 0,7.3728 L0,1.47456 C0,0.660182999 0.642960834,0 1.43609322,0 Z",
    id: "Rectangle",
    fill: "#968BFF"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPot1);
export default __webpack_public_path__ + "static/media/Pot1.430ec9546cc671e6aaf7ae7b6a215e54.svg";
export { ForwardRef as ReactComponent };